import { render } from "./ModificationView.vue?vue&type=template&id=61f00d18&scoped=true"
import script from "./ModificationView.vue?vue&type=script&lang=js"
export * from "./ModificationView.vue?vue&type=script&lang=js"

import "./ModificationView.vue?vue&type=style&index=0&id=61f00d18&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61f00d18"]])

export default __exports__